import { useMemo, useState } from 'react'
import { formatPercent } from '../utils/formatting.js'

export default function StockFilterModal({ stocks, selectedStockCodes, onApply, onClose }) {
  const defaultSelected = selectedStockCodes.length === 0
    ? stocks.map((stock) => stock.code)
    : selectedStockCodes
  const [draftCodes, setDraftCodes] = useState(defaultSelected)
  const [query, setQuery] = useState('')

  const draftSet = new Set(draftCodes)
  const filteredStocks = useMemo(() => {
    const text = query.trim().toLowerCase()
    if (!text) return stocks
    return stocks.filter((stock) => (
      stock.code.toLowerCase().includes(text)
      || stock.name.toLowerCase().includes(text)
    ))
  }, [query, stocks])

  const toggleCode = (code) => {
    setDraftCodes((current) => (
      current.includes(code)
        ? current.filter((item) => item !== code)
        : current.concat(code)
    ))
  }

  return (
    <div className="modal-backdrop">
      <section className="modal" role="dialog" aria-modal="true" aria-label="篩選股票">
        <div className="modal-head">
          <h2>篩選股票</h2>
          <button type="button" className="icon-button" aria-label="關閉篩選" onClick={onClose}>X</button>
        </div>

        <input
          className="search-input"
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="搜尋代號或名稱"
        />

        <div className="filter-actions">
          <button type="button" className="secondary-button" onClick={() => setDraftCodes(stocks.map((stock) => stock.code))}>
            全選
          </button>
          <button type="button" className="secondary-button" onClick={() => setDraftCodes([])}>
            全取消
          </button>
        </div>

        <div className="stock-list">
          {filteredStocks.map((stock) => (
            <label className="stock-option" key={stock.code}>
              <input
                type="checkbox"
                aria-label={`${stock.code} ${stock.name}`}
                checked={draftSet.has(stock.code)}
                onChange={() => toggleCode(stock.code)}
              />
              <span className="mono">{stock.code}</span>
              <span>{stock.name}</span>
              <span className="numeric">{formatPercent(stock.latestWeight)}</span>
            </label>
          ))}
        </div>

        <div className="modal-actions">
          <button type="button" className="secondary-button" onClick={onClose}>
            取消
          </button>
          <button type="button" className="primary-button" onClick={() => onApply(draftCodes)}>
            套用
          </button>
        </div>
      </section>
    </div>
  )
}
